<template>
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="24" style="margin-top: 10px">
                        <span class="title">查询时间:</span>

                        <el-date-picker
                            v-model="search_time"
                            type="datetimerange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="timeChange"
                            style="width: 300px"
                        >
                        </el-date-picker>
                    </el-col>
                </el-row>
            </div>

            <el-button type="primary" icon="el-icon-search" @click="searchserviceFeeLists">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <!-- <el-button type="primary" @click="toExport">导出</el-button> -->
            <el-button :icon="progress_show ? 'el-icon-loading' : 'el-icon-setting'" @click="toExport" :disabled="progress_show">{{
                progress_show ? '导出中...' : '导出'
            }}</el-button>

            <!-- 导出进度条 -->
            <div style="width: 500px; margin: 10px auto" v-if="progress_show">
                <el-progress :percentage="progress_data"></el-progress>
                <i class="el-icon-loading"></i>
                正在导出...
            </div>
        </div>

        <!-- 表格 -->
        <el-table
            :data="tableData"
            class="table"
            ref="multipleTable"
            header-cell-class-name="table-header"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="city.name" label="城市名称"> </el-table-column>

            <!-- <el-table-column prop="admin_name" label="操作人"> </el-table-column> -->
            <el-table-column prop="billno" label="订单编号"> </el-table-column>

            <el-table-column prop="time.YmdHis" label="时间"> </el-table-column>

            <el-table-column prop="mode.alias" label="模式"> </el-table-column>

            <el-table-column prop="amount" label="金额"> </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data1" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>
    </div>
</template>
  
  <script>
var _this;

export default {
    components: {},
    data() {
        return {
            fee_count_log_code: '',
            search_time: '',
            excelData: [],

            excelHead: [],

            progress_show: false,
            progress_data: 0,
            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data1: {
                page: 1,
                limit: 10,
                fixed_time: ''
                // fee_count_log_code_array: '' 为勾选后点击页码翻页搜索数据为0的问题，所以翻页的时候调用此数据
            },
            //搜索数据
            search_data: {
                page: 1,
                limit: 10,
                fixed_time: '',
                fee_count_log_code_array: ''
            },

            result_data: [],

            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.searchserviceFeeLists();
    },

    methods: {
        // 全选或多选
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection);

            var datalist = [];

            for (var i in val) {
                datalist.push(val[i].fee_count_log_code);
            }
            _this.search_data.fee_count_log_code_array = datalist;
            // console.log(_this.search_data.fee_count_log_code_array);
            // console.log(datalist);
        },
        timeChange(val) {
            // console.log(val);

            if (val != null) {
                _this.search_data.fixed_time = JSON.stringify(['between', ..._this.search_time]);
            } else {
                _this.search_data.fixed_time = '';
            }
        },
        searchserviceFeeLists() {
            _this.search_data.page = 1;

            _this.serviceFeeLists();
        },

        //搜索公司列表 导出也是这个接口
        serviceFeeLists() {
            // console.log(_this.search_data);
            _this
                .$post('/service_fee/serviceFeeLogLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.result_data = res.count;
                    _this.tableData = res.count.result;
                })
                .catch((err) => {});
        },
         //搜索公司列表 导出也是这个接口
        serviceFeeLists1() {
            // console.log(_this.search_data);
            _this
                .$post('/service_fee/serviceFeeLogLists', _this.search_data1, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.result_data = res.count;
                    _this.tableData = res.count.result;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data1) {
            //赋值
            _this.search_data1 = search_data1;
            //初始化列表
            _this.serviceFeeLists1(); //解决勾选数据后翻页无数据问题
        },
        // 刷新按钮
        refresh() {
            this.$router.go(0);
        },
        toExport() {
            _this.search_data.page = 1;
            _this.getExcelData();
        },

        getExcelData() {
            _this
                .$post('/service_fee/serviceFeeLogLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    _this.progress_show = true;

                    // console.log(_this.progress_show);

                    if (this.$route.path == '/serviceFeeLogLists') {
                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.count.result.length; i++) {
                            _this.excelData.push({
                                city: res.count.result[i].city.name,
                                billno: res.count.result[i].billno,
                                time: res.count.result[i].time.YmdHis,
                                mode: res.count.result[i].mode.alias,
                                amount: res.count.result[i].amount
                            });
                        }

                        if (res.count.page * res.count.limit < res.count.count) {
                            _this.search_data.page = res.count.page + 1;

                            _this.progress_data = Math.floor(((res.count.page * res.count.limit) / res.count.count) * 100);

                            _this.getExcelData();
                        } else {
                            // console.log(_this.excelData);

                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;
                            _this.progress_data = 0;
                        }
                    } else {
                        _this.progress_show = false;
                        _this.progress_data = 0;
                    }
                })
                .catch((err) => {});
        },

        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = ['城市', '订单编号', '时间', '模式', '金额'];
            const filterVal = ['city', 'billno', 'time', 'mode', 'amount'];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, '城市服务费流水');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        }
    }
};
</script>
  
<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}

</style>